import React, { useEffect, useState } from 'react';
import Link from 'components/Link';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InViewObserver from '../../../components/InViewObserver/InViewObserver';
import s from './TabListingWidget.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const TabListingWidget = props => {
  const [activeTab, setActiveTab] = useState('');
  const [activeListingData, setActiveListingData] = useState([]);
  const [gaSectionName, setGASectionName] = useState('');

  let tabListData = [];
  if (props.item && props.item.tabsData && Array.isArray(props.item.tabsData)) {
    tabListData = props.item.tabsData.slice(0, 2);
  }

  const sectionHeading = props.item && props.item.name;

  const gaLabel =
    sectionHeading && typeof sectionHeading === 'string'
      ? sectionHeading.replace(/ /g, '-')
      : '';

  const fireInViewGA = () => {
    const gaCategory =
      typeof window !== 'undefined' && window.categoryForGA
        ? window.categoryForGA
        : '';
    // Done for removing WEB-articleshowv2 TOIPR-70372
    if (gaCategory === 'WEB-articleshowv2') {
      return;
    }
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: 'scroll',
        gaLabel: gaLabel ? `${gaLabel}_View` : '',
        nonInteraction: true,
      },
    });
  };

  const onTabClick = tabName => {
    if (
      tabName &&
      tabListData &&
      Array.isArray(tabListData) &&
      tabListData.length
    ) {
      const selectedTabData = tabListData.filter(
        tabData => tabData.label && tabData.label === tabName,
      );
      if (
        selectedTabData &&
        Array.isArray(selectedTabData) &&
        selectedTabData.length &&
        selectedTabData[0].label &&
        selectedTabData[0].items
      ) {
        setActiveTab(selectedTabData[0].label);
        setActiveListingData(selectedTabData[0].items);
        setGASectionName(
          selectedTabData[0].gaSectionName
            ? selectedTabData[0].gaSectionName
            : tabName,
        );
      }
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: 'trending stories',
        category: 'tab_change',
        label: tabName,
      });
      // sendGaThroughProps({
      //   data: {
      //     gaCategory:
      //       typeof window !== 'undefined' && window.categoryForGA ? window.categoryForGA : '',
      //     gaAction: 'click',
      //     gaLabel: gaLabel
      //       ? `${gaLabel}_${tabName.replace(/ /g, '-')}`
      //       : `${tabName.replace(/ /g, '-')}`,
      //   },
      // });
    }
  };

  const onStoryClick = (tabName, storyNumber, isSpotlight) => {
    let tabName1;
    if (tabName) {
      tabName = isSpotlight ? 'Spotlight_' : `${tabName.replace(/ /g, '-')}_`;
      tabName1 = isSpotlight ? 'Spotlight' : `${tabName.replace(/ /g, '-')}`;
    }
    sendGaThroughProps({
      data: {
        gaCategory:
          typeof window !== 'undefined' && window.categoryForGA
            ? window.categoryForGA
            : '',
        gaAction: 'click',
        gaLabel: gaLabel
          ? `${gaLabel}_${tabName}click_story_${storyNumber}`
          : `${tabName}click_story_${storyNumber}`,
      },
    });
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'trending stories',
      category: 'story_click',
      label: tabName1,
      story_no: storyNumber + 1,
    });
  };

  useEffect(() => {
    if (
      tabListData &&
      Array.isArray(tabListData) &&
      tabListData.length &&
      tabListData[0].label &&
      tabListData[0].items
    ) {
      setActiveTab(tabListData[0].label);
      setActiveListingData(tabListData[0].items);
      setGASectionName(tabListData[0].gaSectionName);
    }
  }, []);

  const getItemType = (templateName, itemLink) => {
    let itemType = 'news';
    switch (templateName) {
      case 'photostory':
        itemType = 'photostory';
        if (
          itemLink &&
          typeof itemLink === 'string' &&
          itemLink.includes('photogallery.indiatimes.com')
        ) {
          itemType = 'photogallery';
        }
        break;
      case 'video':
        itemType = 'video';
        break;
      case 'spotlight':
        itemType = 'spotlight';
        break;
      case 'lb':
        itemType = 'liveblog';
        break;
      default:
        itemType = 'news';
    }
    return itemType;
  };

  let listingData =
    activeListingData &&
    Array.isArray(activeListingData) &&
    activeListingData.length
      ? activeListingData
      : [];
  if (!listingData || (Array.isArray(listingData) && !listingData.length)) {
    if (
      tabListData &&
      Array.isArray(tabListData) &&
      tabListData.length &&
      tabListData[0].label &&
      tabListData[0].items
    ) {
      listingData = tabListData[0].items;
    }
  }

  let currentTab = activeTab || '';
  if (!currentTab || currentTab === '') {
    if (
      tabListData &&
      Array.isArray(tabListData) &&
      tabListData.length &&
      tabListData[0].label &&
      tabListData[0].items
    ) {
      currentTab = tabListData[0].label;
    }
  }

  return (
    <>
      {tabListData && Array.isArray(tabListData) && tabListData.length ? (
        <InViewObserver
          inViewCallback={() => {
            fireInViewGA();
            analyticsWrapper('ga4', {
              event: 'user_shown',
              type: 'trending stories',
            });
          }}
        >
          <div className={s.wrapper}>
            {sectionHeading && (
              <h2 className={s.tabwapTitle}>{sectionHeading}</h2>
            )}
            <div className={s.contentwrapper}>
              <div className={s.tabwap}>
                {tabListData.map(tabData => (
                  <>
                    {tabData.label &&
                      tabData.items &&
                      Array.isArray(tabData.items) &&
                      tabData.items.length && (
                        <div
                          className={`${s.tab} ${
                            currentTab === tabData.label ? s.active : ''
                          }`}
                          onClick={() => {
                            onTabClick(
                              tabData.label,
                              tabData.gaSectionName
                                ? tabData.gaSectionName
                                : tabData.label,
                            );
                          }}
                        >
                          <span>{tabData.label}</span>
                        </div>
                      )}
                  </>
                ))}
              </div>
              {tabListData.map(tabData => (
                <ul
                  className={`${s.list} ${
                    tabData.label && currentTab === tabData.label
                      ? s.listActive
                      : ''
                  }`}
                >
                  {tabData.label &&
                    tabData.items &&
                    Array.isArray(tabData.items) &&
                    tabData.items.length &&
                    tabData.items.map((item, index) => {
                      const itemClass = getItemType(item.tn, item.wu);
                      return (
                        <li>
                          {itemClass && itemClass === 'liveblog' ? (
                            <i className={`${s.liveBtn} ${s.red}`} />
                          ) : (
                            <i
                              className={`${
                                item.cs && item.cs === 'prime'
                                  ? s.prime
                                  : `${s[itemClass] || s.news}`
                              }`}
                            />
                          )}

                          <Link
                            to={item.wu}
                            target="_blank"
                            key={item.id}
                            onClick={() => {
                              onStoryClick(
                                gaSectionName || currentTab,
                                index,
                                item.tn && item.tn === 'spotlight',
                              );
                            }}
                          >
                            {item.hl}
                          </Link>
                        </li>
                      );
                    })}
                </ul>
              ))}
            </div>
          </div>
        </InViewObserver>
      ) : null}
    </>
  );
};

export default TabListingWidget;
